import { i18n } from "@lingui/core"

type PriceViewProps = {
  price: string
  productId?: string
  section?: string
}

// We only add locales that have a different decimal separator than "."
const DECIMAL_SEPARATOR: Record<string, string> = {
  "es-MX": ".",
}

export function PriceView({ price, productId, section }: PriceViewProps) {
  const decimalSeparator = DECIMAL_SEPARATOR[i18n.locale] || ","

  const optionalAttributes = {
    ...(productId != null || section != null
      ? {
          "data-testid": `price-view${section != null ? `-${section}` : ""}${
            productId != null ? `-product-${productId}` : ""
          }`,
        }
      : {}),
  }

  if (!price.includes(decimalSeparator)) {
    return <span {...optionalAttributes}>{price}</span>
  }

  const [entire, cents] = price.split(decimalSeparator)

  return (
    <span {...optionalAttributes}>
      {entire}
      <sup>{cents}</sup>
    </span>
  )
}
